// extracted by mini-css-extract-plugin
export default {"circle":"AnimationPage_circle__3rlXI","progressBarWrapper":"AnimationPage_progressBarWrapper__c3o9S"};